export const AGENCY_NAME_OPTIONS = [
  '9Yardov',
  'А2 Групп',
  'Adaurum',
  'ADV',
  'Advisor',
  'AMDG',
  'Arenamb',
  'Arrow Media',
  'Artics',
  'Brand Factory',
  'BureauSuchkov',
  'Calltouch',
  'Centra',
  'Consortium',
  'DA Skipper',
  'DEL',
  'DeltaClick',
  'Dentsu',
  'Direct',
  'Easy Media',
  'F1',
  'First Data',
  'Fistashki',
  'giraff',
  'Group4Media',
  'Havas Media',
  'I-media',
  'ICE',
  'Icom',
  'iContext',
  'iContext_Registratura',
  'Icturbo',
  'Igronik',
  'Innolaba',
  'iProspect',
  'Isintel',
  'IT-Agency',
  'IVK Media',
  'Kit Soler',
  'MDP',
  'Mediaguru',
  'MediaInstinct',
  'MediaNation',
  'MediaWorks',
  'MGCom',
  'MobX',
  'Nectarin',
  'Next Level',
  'NMI',
  'OTC',
  'PBD',
  'Profitator',
  'RealWeb',
  'Resolution OMD',
  'RMAA',
  'Rocket10',
  'RoRe Group',
  'ROSST',
  'RTA',
  'SA',
  'Sbermarketing',
  'Sberseller',
  'SF',
  'Site-seeing',
  'SkyTec',
  'SocialCraft',
  'Starlink',
  'Stream',
  'Turbotarget',
  'Twiga',
  'Uforce',
  'UM',
  'UMG',
  'Weborama',
  'WIN2WIN',
  'YourMarketingTeam',
  'Zorka',
];
